import useManagedAccountPageEventLogger
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/managedAccountPage.eventLogging';

const useLegendEventHandler = () => {
  const { logPerformanceChartEvent } = useManagedAccountPageEventLogger();

  const handleLegendClick = (data) => {
    logPerformanceChartEvent('Legend', {
      name: data.value,
    });
  };

  return {
    handleLegendClick,
  };
};

export default useLegendEventHandler;
